<template>
  <div :class="{'has-logo':showLogo}">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        :default-openeds="defaultOpeneds"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in getCurrentMenu"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'
import ConstantRoutes from '@/router/constantRoutes'
export default {
  components: { SidebarItem, Logo },
  computed: {
    ...mapGetters(['authList', 'sidebar', 'hotelCode', 'hotelFrom']),
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    defaultOpeneds() {
      const route = this.$route
      const { meta, path } = route
      if (meta.activeMenu) {
        return [meta.activeMenu]
      }
      if (path.includes('/guest')) {
        return ['/guest/roomOrder', '/guest/order']
      }
      return [this.$route.matched.slice(-2)[0].path]
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return false
    },
    currentDomainConfig() {
      return this.$store.state.app.currentColorLogo || {}
    },
    hiddenSidebarMenuUrls() {
      return this.currentDomainConfig.hiddenSidebarMenuUrls || []
    },
    getCurrentMenu() {
      let currentMenu = null
      if (this.$route.path.includes('/operate-log')) {
        currentMenu = ConstantRoutes.find(item => item.path === '/operate-log')
      } else {
        currentMenu = this.authList.find(item => {
          return (
            item.meta &&
          item.meta.navMenu &&
          item.meta.navMenu === this.$route.meta.navMenu
          )
        })
      }
      if (currentMenu) {
        if (this.$route.query.hShow) {
          const thirdList = []
          currentMenu.children.forEach((item) => {
            if (item.meta.third) {
              thirdList.push(item)
            }
          })
          return thirdList
        }
        if (this.hotelFrom === 'beyondhost') {
          currentMenu.children.forEach((item) => {
            if (item.meta.isJudge) {
              return (item.children.forEach((child, idx) => {
                if (child.meta.isShowLeft) {
                  item.children.splice(idx, 1)
                }
              }))
            }
          })
        }
        if (this.$route.path.includes('/operate-log') && this.$store.getters.isNightAuditGrayEnv) {
          return this.filterHiddenSidebarMenu(currentMenu.children.filter(item => item.path !== '/operate-log/nightAuditLog'))
        }
        return this.filterHiddenSidebarMenu(currentMenu.children)
      } else {
        return []
      }
    } // accountSuitList
  },
  methods: {
    filterHiddenSidebarMenu(children) {
      if (!this.hiddenSidebarMenuUrls.length) {
        return children
      }
      return children
        .filter((item) => {
          const menuUrl = item.path || item.url
          return !this.hiddenSidebarMenuUrls.includes(menuUrl)
        })
        .map((item) => {
          if (item.children && item.children.length) {
            return {
              ...item,
              children: this.filterHiddenSidebarMenu(item.children)
            }
          }
          return item
        })
    }
  }
}
</script>
